import React, { Component, Fragment } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import OrganisationSnippetsTable from '../components/OrganisationSnippetsTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import DismissableAlert from '../components/DismissableAlert';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './OrganisationSnippets.css';

class OrganisationSnippets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            snippets: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            },
            selectedSnippets: new Set(),
            selectedSnippetsData: new Map(),
            selectAllMode: false,
            selectAllPages: false,
            totalSnippets: 0,
            excludedSnippets: new Set(),
            excludedSnippetsData: new Map()
        };
    }

    componentDidMount() {
        this.loadOrganisationInformation();
        this.loadOrganisationSnippetsFromServer();
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    saveSnippet(snippet, newName) {
        var self = this;
        axios
            .put(`${config.baseURL}/snippets/${snippet.uuid}`, {
                name: newName
            })
            .then(function(response) {
                self.loadOrganisationSnippetsFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    deleteSnippet(snippet) {
        var self = this;
        axios
            .delete(`${config.baseURL}/snippets/${snippet.uuid}`)
            .then(function(response) {
                self.loadOrganisationSnippetsFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationSnippetsFromServer() {
        var self = this;
        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}/snippets`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    snippets: response.data.snippets,
                    pageCount: response.data.pageCount,
                    totalSnippets: response.data.itemCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadOrganisationSnippetsFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadOrganisationSnippetsFromServer();
    };

    handleSelectSnippet = (snippetUuid, isSelected) => {
        let selectedSnippets = new Set(this.state.selectedSnippets);
        let selectedSnippetsData = new Map(this.state.selectedSnippetsData);
        let excludedSnippets = new Set(this.state.excludedSnippets);
        let excludedSnippetsData = new Map(this.state.excludedSnippetsData);

        if (isSelected) {
            if (this.state.selectAllMode) {
                excludedSnippets.delete(snippetUuid);
                excludedSnippetsData.delete(snippetUuid);
            } else {
                selectedSnippets.add(snippetUuid);
                const snippetData = this.state.snippets.find(s => s.uuid === snippetUuid);
                if (snippetData) {
                    selectedSnippetsData.set(snippetUuid, snippetData);
                }
            }
        } else {
            if (this.state.selectAllMode) {
                excludedSnippets.add(snippetUuid);
                const snippetData = this.state.snippets.find(s => s.uuid === snippetUuid);
                if (snippetData) {
                    excludedSnippetsData.set(snippetUuid, snippetData);
                }
            } else {
                selectedSnippets.delete(snippetUuid);
                selectedSnippetsData.delete(snippetUuid);
            }
        }

        this.setState({
            selectedSnippets,
            selectedSnippetsData,
            excludedSnippets,
            excludedSnippetsData
        });
    };

    handleSelectAll = (isSelectAll) => {
        if (isSelectAll) {
            // Select all items on current page only - DON'T set selectAllMode yet
            const currentPageSnippetUuids = new Set(this.state.snippets.map(s => s.uuid));
            const currentPageSnippetsData = new Map(this.state.snippets.map(s => [s.uuid, s]));

            this.setState({
                selectAllMode: false,  // Keep this false - only for current page
                selectAllPages: false,
                selectedSnippets: currentPageSnippetUuids,
                selectedSnippetsData: currentPageSnippetsData,
                excludedSnippets: new Set(),
                excludedSnippetsData: new Map()
            });
        } else {
            this.setState({
                selectAllMode: false,
                selectAllPages: false,
                selectedSnippets: new Set(),
                selectedSnippetsData: new Map(),
                excludedSnippets: new Set(),
                excludedSnippetsData: new Map()
            });
        }
    };

    handleSelectAllPages = () => {
        this.setState({
            selectAllMode: true,   // NOW we set selectAllMode true
            selectAllPages: true,
            selectedSnippets: new Set(),
            selectedSnippetsData: new Map()
        });
    };

    showBulkDeleteConfirmation = () => {
        const { t } = this.props;

        let bodyContent;

        if (this.state.selectAllPages) {
            const effectiveCount = this.state.totalSnippets - this.state.excludedSnippets.size;
            bodyContent = (
                <div>
                    <p><strong>Warning: This will delete {effectiveCount} snippets across all pages!</strong></p>
                    <p>This includes all snippets that match your current search {this.state.search ? ` for "${this.state.search}"` : ''}
                    {this.state.excludedSnippets.size > 0 && <span>, excluding {this.state.excludedSnippets.size} manually deselected items</span>}.</p>
                    <p><em>This action cannot be undone.</em></p>
                </div>
            );
        } else {
            const selectedItems = Array.from(this.state.selectedSnippetsData.values());
            bodyContent = (
                <div>
                    <p><strong>This will delete {selectedItems.length} selected snippet{selectedItems.length === 1 ? '' : 's'}:</strong></p>
                    <ul style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                        {selectedItems.map(item => (
                            <li key={item.uuid}><strong>{item.name}</strong></li>
                        ))}
                    </ul>
                </div>
            );
        }

        this.dialog.show({
            title: t('Dialog.warning'),
            body: bodyContent,
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => this.dialog.hide(),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.confirmBulkDelete(),
                    'btn-danger'
                )
            ],
            bsSize: 'large'
        });
    };

    handleBulkDelete = () => {
        this.showBulkDeleteConfirmation();
    };

    confirmBulkDelete = () => {
        const { uuid } = this.props.match.params;

        // Determine if we're using "select all" mode (either current page or all pages)
        const usingSelectAll = this.state.selectedSnippets.size > 0 || this.state.selectAllPages;

        const payload = {
            selectAll: usingSelectAll,
            selectAllPages: this.state.selectAllPages,
            search: this.state.search,
            snippets: this.state.selectAllPages ? [] : Array.from(this.state.selectedSnippets),
            excludedSnippets: this.state.selectAllPages ? Array.from(this.state.excludedSnippets) : []
        };

        console.log('🔍 BULK DELETE PAYLOAD:', {
            selectAll: payload.selectAll,
            selectAllPages: payload.selectAllPages,
            itemsCount: payload.snippets ? payload.snippets.length : 0,
            items: payload.snippets,
            excludedItemsCount: payload.excludedSnippets.length,
            search: payload.search,
            state: {
                selectedItemsSize: this.state.selectedSnippets ? this.state.selectedSnippets.size : 0,
                selectAllPages: this.state.selectAllPages,
                totalItems: this.state.totalSnippets
            }
        });

        const wasSelectAllPagesWithSearch = this.state.selectAllPages && this.state.search;

        axios
            .post(`${config.baseURL}/organisations/${uuid}/snippets/bulk-delete`, payload)
            .then((response) => {
                const newState = {
                    selectedSnippets: new Set(),
                    selectedSnippetsData: new Map(),
                    excludedSnippets: new Set(),
                    excludedSnippetsData: new Map(),
                    selectAllMode: false,
                    selectAllPages: false
                };

                if (wasSelectAllPagesWithSearch) {
                    newState.search = '';

                    const url = new URL(window.location.href);
                    url.searchParams.delete('search');
                    window.history.pushState(null, null, url);
                }

                this.setState(newState, () => {
                    this.loadOrganisationSnippetsFromServer();
                });
            })
            .catch(function(error) {
                console.log(error);
                this.setState({
                    error: {
                        hidden: false,
                        title: `${this.props.t('Dialog.error')}:`,
                        style: 'danger',
                        message: (error.response && error.response.data && error.response.data.message) || 'Failed to delete snippets'
                    }
                });
            }.bind(this));
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'OrganisationSnippets.title'
        )}`;

        const selectedCount = this.state.selectAllPages
            ? this.state.totalSnippets - this.state.excludedSnippets.size
            : this.state.selectedSnippets.size;
        const hasSelection = selectedCount > 0;

        // Show banner when: all items on current page are selected AND there are more pages
        const allCurrentPageSelected = this.state.selectedSnippets.size === this.state.snippets.length && this.state.snippets.length > 0;
        const showSelectAllPagesBanner = allCurrentPageSelected && !this.state.selectAllPages && this.state.totalSnippets > this.state.snippets.length;

        const user = this.state.user;
        const { uuid } = this.props.match.params;

        return (
            <div className="OrganisationSnippets">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('OrganisationSnippets.title')}{' '}
                                    <small>
                                        {this.state.organisation_name}
                                    </small>
                                    {this.state.userIsAuthorized(user, [
                                        'staff_super_admin',
                                        'staff_admin',
                                        'organisation_admin'
                                    ]) ? (
                                        <Fragment>
                                            <Link type="submit" className="btn btn-primary" to={`/organisations/${uuid}/snippets/create?rel=player`} style={{marginLeft: '0.5rem'}}>
                                                <em className="fa fa-plus fa-fw" />{' ' + t('OrganisationSnippets.add_snippet')}
                                            </Link>
                                        </Fragment>
                                    ) : null}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${uuid}`}>
                                            {t('Dashboard.title')}
                                        </Link>
                                    </li>

                                    <li className="active">
                                        <i className="fa fa-puzzle-piece" />{' '}
                                        {t('SideNavigation.globalsnippets')}
                                    </li>
                                </ol>

                                <DismissableAlert
                                    title={this.state.error.title}
                                    message={this.state.error.message}
                                    hidden={this.state.error.hidden}
                                    style={this.state.error.style}
                                />
                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px' }}>
                                                    <form
                                                        role="search"
                                                        onSubmit={this.handleSubmit}
                                                        style={{ flex: hasSelection ? 1 : 1 }}
                                                    >
                                                        <FormGroup controlId="search" style={{ margin: 0 }}>
                                                            <InputGroup style={{ height: '38px' }}>
                                                                <FormControl
                                                                    type="text"
                                                                    value={this.state.search}
                                                                    onChange={this.handleChange}
                                                                    placeholder={t('Search')}
                                                                    style={{ height: '38px' }}
                                                                />
                                                                <InputGroup.Button>
                                                                    <Button
                                                                        onClick={this.handleSubmit}
                                                                        style={{ height: '38px' }}
                                                                    >
                                                                        <i className="glyphicon glyphicon-search" />
                                                                    </Button>
                                                                </InputGroup.Button>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </form>

                                                    {hasSelection && (
                                                        <div className="alert alert-info" style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            margin: 0,
                                                            padding: '8px 16px',
                                                            fontSize: '14px',
                                                            whiteSpace: 'nowrap',
                                                            flex: 2,
                                                            minWidth: '350px',
                                                            height: '38px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            <span>
                                                                <strong>{selectedCount}</strong> snippet{selectedCount === 1 ? '' : 's'} selected
                                                                {this.state.selectAllPages && <span> (all pages)</span>}
                                                                {showSelectAllPagesBanner && (
                                                                    <span>
                                                                        {' '}
                                                                        <a
                                                                            href="#"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.handleSelectAllPages();
                                                                            }}
                                                                            style={{ textDecoration: 'underline', color: '#31708f', fontWeight: 'bold' }}
                                                                        >
                                                                            Select all {this.state.totalSnippets} snippets?
                                                                        </a>
                                                                    </span>
                                                                )}
                                                            </span>
                                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                                <Button
                                                                    className="btn-default btn-sm"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            selectedSnippets: new Set(),
                                                                            selectedSnippetsData: new Map(),
                                                                            excludedSnippets: new Set(),
                                                                            excludedSnippetsData: new Map(),
                                                                            selectAllMode: false,
                                                                            selectAllPages: false
                                                                        });
                                                                    }}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className='far fa-square' /> {t('MediaSnippetMediaLibrary.select_none')}
                                                                </Button>
                                                                <Button
                                                                    className="btn-danger btn-sm"
                                                                    onClick={this.handleBulkDelete}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className="fa fa-trash" /> Delete Selected
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <OrganisationSnippetsTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        snippets={this.state.snippets}
                                        uuid={uuid}
                                        onDelete={this.deleteSnippet.bind(this)}
                                        onSelectSnippet={this.handleSelectSnippet}
                                        onSelectAll={this.handleSelectAll}
                                        selectedSnippets={this.state.selectedSnippets}
                                        excludedSnippets={this.state.excludedSnippets}
                                        selectAllMode={this.state.selectAllMode}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(OrganisationSnippets);
